import { useSearchParams } from "react-router-dom";
import { Button, Tooltip } from "antd";
import { MenuUnfoldOutlined, UnorderedListOutlined } from "@ant-design/icons";
import ThesisCompactToolbar from "@/components/ThesisCompactToolbar";
import ThesisWorkspaceChrome from "@/components/ThesisWorkspaceChrome";

/** 正文顶栏：左写作工具，右云同步/账号 */
const TopNav = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const tocOpen = searchParams.get('toc') === '1'
  const sidebarHidden = searchParams.get('sidebar') !== 'open'

  const toggleToc = () => {
    const next = new URLSearchParams(searchParams)
    if (tocOpen) next.delete('toc')
    else next.set('toc', '1')
    setSearchParams(next)
  }

  const expandBrief = () => {
    const next = new URLSearchParams(searchParams)
    next.set('sidebar', 'open')
    next.delete('sidebar[detail]')
    setSearchParams(next)
  }

  return (
    <div className="thesis-topbar h-12 flex-none flex items-center z-30 min-w-0 contain-strict px-2 gap-2 border-b border-[var(--tt-topbar-line,rgba(229,226,220,0.9))] bg-[var(--tt-topbar-bg,rgba(242,240,235,0.86))] backdrop-blur-sm">
      {sidebarHidden && (
        <Tooltip title="展开开题卡">
          <Button
            type="text"
            shape="circle"
            size="small"
            className="hidden lg:inline-flex shrink-0"
            icon={<MenuUnfoldOutlined />}
            onClick={expandBrief}
            aria-label="展开开题卡"
          />
        </Tooltip>
      )}
      <Button
        type="text"
        shape="round"
        size="small"
        className="md:hidden shrink-0"
        icon={<UnorderedListOutlined />}
        onClick={toggleToc}
      >
        目录
      </Button>
      <div className="grow flex items-center min-w-0 overflow-x-auto">
        <ThesisCompactToolbar />
      </div>
      <ThesisWorkspaceChrome />
    </div>
  )
}

export default TopNav
